import _ from 'lodash';
import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';

import api from '@api';
import constants from '@constants';

/** お問い合わせSubmit */
export const sendContact = async (
  value: any,
  formikAction: FormikHelpers<any>,
  me: MeStore,
  reCaptchaToken: null | string,
  recaptchaRef: any
) => {
  // tokenがない場合
  if (_.isEmpty(reCaptchaToken)) {
    formikAction.setSubmitting(false);
    return;
  }

  try {
    if (me.id && me.teamId) {
      await api.contact.send({
        userId: me.id,
        teamId: me.teamId,
        name: value.name,
        email: value.email,
        message: value.message,
      });
    } else {
      await api.contact.send({
        name: value.name,
        email: value.email,
        message: value.message,
      });
    }
    notify('お問い合わせを送信しました', 'success');
    formikAction.resetForm();
    recaptchaRef.current.reset();
  } catch (error) {
    notify(constants.ERRORS.UNKNWON, 'error');
  } finally {
    formikAction.setSubmitting(false);
  }
};
